import logger from '@utils/logger';
import { SolutionsEnum } from 'src/types';
import BubblesAlerts from './BubblesAlerts';
import BubblesDetection from './BubblesDetection';
import BubblesMonitor from './BubblesMonitor';
import BubblesVerification from './BubblesVerification';

import './Bubbles.css';

interface BubblesProps {
	id: SolutionsEnum;
}

const BUBBLES_COMPONENTS = {
	[SolutionsEnum.MONITOR]: BubblesMonitor,
	[SolutionsEnum.DETECTION]: BubblesDetection,
	[SolutionsEnum.VERIFICATION]: BubblesVerification,
	[SolutionsEnum.ALERTS]: BubblesAlerts
} as const;

const Bubbles = ({ id }: BubblesProps) => {
	if (!(id in BUBBLES_COMPONENTS)) {
		logger.warn({ id }, 'Bubbles component not found');
		return null;
	}

	const BubbleComponent = BUBBLES_COMPONENTS[id as SolutionsEnum];

	return <BubbleComponent />;
};

export default Bubbles;
